import axios from 'axios'
import { useState, useEffect, createRef } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { format } from 'date-fns'
// import { toJS } from 'mobx'
import { menuMap } from '../../constant/Constant'
import ConfigAPI from '../../constant/ConfigAPI'
import useMapStore from '../../stores/useMapStore'
import { ElementRef, MapViewClickType, MapCallbackEventType, LocationType } from '../../stores/types/useMapStoreType'
import { Point } from '@arcgis/core/geometry'
// import Graphic from '@arcgis/core/Graphic'
// import BasemapToggle from '@arcgis/core/widgets/BasemapToggle'
import useLoadingStore from '../../stores/useLoadingStore'
// import { ThumbUpSharp } from '@mui/icons-material'
// import { PositionsProps } from '@mui/system'
import { CallBackOpenDialog } from '../../control/dialogAlert/withDialog'
import { RootStateType } from '../../redux/reducer/rootReducer'
import { getMapMenuByPermission } from '../../util/utilityFunction'
import useFormFeedbackStore from '../../stores/useFormFeedbackStore'
import useFormReportStore from '../../stores/useFormReportStore'
import useMapUpperBarStore from '../../stores/useMapUpperBarStore'

export type useMapType = typeof useMap
type useMapProps = CallBackOpenDialog
const useMap = (props: useMapProps) => {
    const { permissions } = useSelector(({ profile }: RootStateType) => profile)
    const { openDialog } = props
    const { t } = useTranslation()
    const mapStore = useMapStore()
    const mapUpperBarStore = useMapUpperBarStore()
    const refElementMap = createRef<HTMLDivElement>()
    const refComponentTopLeft = createRef<HTMLDivElement>()
    const refComponentTopRight = createRef<HTMLDivElement>()
    const refComponentBottomScreenWeb = createRef<HTMLDivElement>()
    const refComponentBottomScreenMobile = createRef<HTMLDivElement>()
    const refElementLocationRealtime = createRef<HTMLDivElement>()
    const [searchData, setSearchData] = useState<SearchDataType>()
    const [identifyData, setIdentifyData] = useState<StationType>()
    const [dataTermsAndConditions, setDataTermsAndConditions] = useState<TermsAndConditionsType>({})
    const [openDrawer, setOpenDrawer] = useState(false)
    const [openSnackbar, setOpenSnackbar] = useState(false)
    const [openDialogWelcome, setOpenDialogWelcome] = useState(false)
    const [openDialogSearchGuide, setOpenDialogSearchGuide] = useState(false)
    const [openPopupIdentifyResult, setOpenPopupIdentifyResult] = useState(false)
    const [openDialogLocationBlock, setOpenDialogLocationBlock] = useState(false)

    const [visiblePinLayer, setVisiblePinLayer] = useState(true)
    const [visibleCoverageAreaLayer, setVisibleCoverageAreaLayer] = useState(false)
    const [visibleAntennaPatternLayer, setVisibleAntennaPatternLayer] = useState(false)
    const [isWaitingGetCurrentLocation, setIsWaitingGetCurrentLocation] = useState(false)

    const [expandedResult, setExpandedResult] = useState(false)
    const [menuList, setMenuList] = useState<MapMenuType[]>(menuMap)

    const [dataContact, setDataContact] = useState<ContactUsType>({})

    const [checkLoading, setCheckLoading] = useState({
        mapLoaded: false,
        stationLoaded: false,
        systemMapLoaded: false,
        //profileLoaded: false,
        contentLoaded: false,
        contactLoaeded: false,
    })

    const loadingStore = useLoadingStore()
    const formFeedbackStore = useFormFeedbackStore()
    const formReportStore = useFormReportStore()

    useEffect(() => {
        if (formFeedbackStore.alertSuccess) {
            if (openDialog) {
                openDialog({
                    title: t('ALERT.TITLE.NOTIFY'),
                    content: 'ขอบคุณสำหรับข้อเสนอแนะ เราจะพัฒนา และปรับปรุงระบบให้ดียิ่งขึ้น',
                    displayBtnClose: true,
                    afterBtnClose: () => {
                        formFeedbackStore.setAlertSuccess(false)
                    },
                })
            }
        }
    }, [formFeedbackStore.alertSuccess])

    useEffect(() => {
        loadMap()
        checkDisplayWelcomeDialog()
        callServiceTermsAndConditions()
        callServiceContact()
    }, [])

    useEffect(() => {
        const permissionMenu = getMapMenuByPermission(permissions)
        setMenuList(permissionMenu)
    }, [permissions])

    useEffect(() => {
        const check = globalThis.localStorage.getItem(`${process.env.REACT_APP_WELCOME_DIALOG}`)

        if (
            dataTermsAndConditions?.versionDateTime &&
            check !== `true ${format(new Date(dataTermsAndConditions?.versionDateTime), 'yyyy-mm-dd hh:mm:ss')}`
        ) {
            setOpenDialogWelcome(true)
        } else {
            const url = globalThis.location.href
            if (
                check &&
                !url.includes('report-feedback') &&
                !url.includes('report-survey') &&
                !url.includes('map-layer')
            ) {
                setIsWaitingGetCurrentLocation(true)
            }
        }
    }, [dataTermsAndConditions])

    useEffect(() => {
        if (mapStore.identifyResult) {
            setIdentifyData(mapStore.identifyResult)
            setOpenPopupIdentifyResult(true)
        }
    }, [mapStore.identifyResult])

    useEffect(() => {
        if (mapStore.searchResult) {
            const bestStation: StationType[] = []
            const { probability, best_server, second_server, third_server } = mapStore.searchResult
            if (best_server) {
                best_server.no = 1
                best_server.activeResult = true
                bestStation.push(best_server)
            }
            if (second_server) {
                second_server.no = 2
                bestStation.push(second_server)
            }
            if (third_server) {
                third_server.no = 3
                bestStation.push(third_server)
            }

            const data: SearchDataType = {
                probability: probability,
                stations: bestStation,
            }
            setSearchData(data)

            setOpenPopupIdentifyResult(false)
            setExpandedResult(true)
        } else {
            setSearchData({})
        }
    }, [mapStore.searchResult])

    useEffect(() => {
        let allLoaded = true
        for (let key in checkLoading) {
            if (!checkLoading?.[key]) {
                allLoaded = false
            }
        }

        if (allLoaded) {
            loadingStore.setLoading(false)
            if (isWaitingGetCurrentLocation) {
                handleClickCurrentLocation()
                setIsWaitingGetCurrentLocation(false)
            }
        }
    }, [checkLoading])

    useEffect(() => {}, [mapUpperBarStore.anchorElResult, mapUpperBarStore.anchorElNoResult])

    const callServiceTermsAndConditions = async () => {
        try {
            loadingStore.setLoading(true)
            const url = `${process.env.REACT_APP_API}/api/content/termsandconds`
            const result = await axios.get(url, ConfigAPI)

            if (result.data) {
                setDataTermsAndConditions(result.data)
            }

            return { result }
        } catch (error) {
            return { error }
        } finally {
            setCheckLoading((prevState) => ({
                ...prevState,
                contentLoaded: true,
            }))
            //loadingStore.setLoading(false)
        }
    }

    const callServiceContact = async () => {
        try {
            loadingStore.setLoading(true)
            const url = `${process.env.REACT_APP_API}/api/content/contactus`
            const result = await axios.get(url, ConfigAPI)

            if (result.data) {
                setDataContact(result.data)
            }

            return { result }
        } catch (error) {
            return { error }
        } finally {
            setCheckLoading((prevState) => ({
                ...prevState,
                contactLoaeded: true,
            }))
            //loadingStore.setLoading(false)
        }
    }

    const checkDisplayWelcomeDialog = () => {
        const check = globalThis.localStorage.getItem(`${process.env.REACT_APP_WELCOME_DIALOG}`)
        if (
            dataTermsAndConditions?.versionDateTime &&
            check !== `true ${format(new Date(dataTermsAndConditions?.versionDateTime), 'yyyy-mm-dd hh:mm:ss')}`
        ) {
            setOpenDialogWelcome(true)
        }
    }

    const handleClickAcceptDialogWelcome = () => {
        globalThis.localStorage.setItem(
            `${process.env.REACT_APP_WELCOME_DIALOG}`,
            `true ${format(new Date(dataTermsAndConditions?.versionDateTime || ''), 'yyyy-mm-dd hh:mm:ss')}`,
        )
        handleClickCurrentLocation()
        setOpenDialogWelcome(false)
    }

    const loadMap = async () => {
        const elementRef: ElementRef = {
            elementDiv: refElementMap.current ?? undefined,
            componentTopLeft: refComponentTopLeft.current ?? undefined,
            componentTopRight: refComponentTopRight.current ?? undefined,
            componentBottomScreenWeb: refComponentBottomScreenWeb.current ?? undefined,
            componentBottomScreenMobile: refComponentBottomScreenMobile.current ?? undefined,
        }

        const mapEventType: MapCallbackEventType = {
            onViewLoaded: handleMapLoaded,
            onStationLoaded: handleStationLoaded,
            onSystemMapLoaded: handleSystemMapLoaded,
            onViewClickIdentify: handleMapClickIdentify,
            onViewClickSearch: handleMapClickSearchByPoint,
            onViewDrag: handleMapDrag,
        }

        //loadingStore.setLoading(true)
        mapStore.createMap(elementRef, mapEventType)
    }

    const zoomToPoint = (param: LocationType) => {
        const { latitude, longitude } = param
        if (latitude && longitude) {
            mapStore._map.removeAll()

            const pt = new Point({
                latitude,
                longitude,
            })

            mapStore._view.goTo({
                center: [pt],
                zoom: 17,
            })
        }
    }

    const handleMapLoaded = () => {
        //Move to On Station Loaded
        //loadingStore.setLoading(true)
        //loadingStore.setLoading(false)
        setCheckLoading((prevState) => ({
            ...prevState,
            mapLoaded: true,
        }))
    }

    const handleStationLoaded = () => {
        setCheckLoading((prevState) => ({
            ...prevState,
            stationLoaded: true,
        }))
        //loadingStore.setLoading(false)
    }

    const handleSystemMapLoaded = () => {
        setCheckLoading((prevState) => ({
            ...prevState,
            systemMapLoaded: true,
        }))
    }

    const handleMapClickIdentify = async (hitTestResult: __esri.HitTestResult) => {
        if (hitTestResult.results.length > 0) {
            try {
                loadingStore.setLoading(true)
                const result = await mapStore.identifyMapStation(hitTestResult)
                loadingStore.setLoading(false)
                if (result.data) {
                    if (typeof result.data !== 'string') {
                        if (result.layerId === 'report-data-layer') {
                            const reportItem = result.data as ReportItemDataType
                            try {
                                loadingStore.setLoading(true)
                                if (reportItem.reportType === 'survey') {
                                    const dataSurvey = await formReportStore.getSurveyDetail(
                                        reportItem.dataId as number,
                                    )
                                    if (dataSurvey) {
                                        formReportStore.setSurveyDetail(dataSurvey)
                                        if (reportItem.location) {
                                            mapStore.zoomLocationByLatLon(reportItem.location, reportItem.dataId, 12)
                                        }
                                        formReportStore.setIsOpenSurveyDetail(true)
                                    }
                                } else if (reportItem.reportType === 'feedback') {
                                    const dataFeedback = await formReportStore.getFeedbackDetail(
                                        reportItem.dataId as number,
                                    )
                                    if (dataFeedback) {
                                        formReportStore.setFeedbackDetail(dataFeedback)
                                        if (reportItem.location) {
                                            mapStore.zoomLocationByLatLon(reportItem.location, reportItem.dataId, 12)
                                        }
                                        formReportStore.setIsOpenFeedbackDetail(true)
                                    }
                                }
                            } finally {
                                loadingStore.setLoading(false)
                            }
                        } else {
                            const station = result.data as StationType
                            loadingStore.setLoading(true)
                            if (!mapStore._arrHideStation.every((grp) => grp.visible === true)) {
                                const current_location_point = new Point({
                                    latitude: mapStore._receptorLocation.latitude,
                                    longitude: mapStore._receptorLocation.longitude,
                                })
                                const station_location_point = new Point({
                                    latitude: station.latitude,
                                    longitude: station.longitude,
                                })
                                const { distance, azimuth } = mapStore.calculateDistanceAndAzimuthByTwoPoint(
                                    current_location_point,
                                    station_location_point,
                                )
                                station.distance = distance
                                station.azimuth = azimuth
                            }

                            setIdentifyData(station)
                            setOpenPopupIdentifyResult(true)
                            loadingStore.setLoading(false)
                        }
                    }
                } else {
                    setOpenPopupIdentifyResult(false)
                }
            } catch (error) {
                console.log(error)
            } finally {
                loadingStore.setLoading(false)
            }
        }
    }

    const handleMapClickSearchByPoint = async (point: __esri.Point) => {
        setOpenSnackbar(false)
        mapStore.setViewClickEvent(MapViewClickType.Identify)
        const { longitude, latitude } = point
        if (longitude && latitude) {
            searchStationByLatLon(longitude, latitude, t('ALERT.CONTENT.STATION_NOT_FOUND_MAP_POINT'))
            mapStore.setSelectedLocation({ latitude, longitude })
        }
    }

    const searchStationByLatLon = async (longitude: number, latitude: number, alertContent: string) => {
        try {
            loadingStore.setLoading(true)
            const result = await mapStore.getSearchStationData(latitude, longitude)
            if (result.result?.data) {
                mapStore.drawSearchStationResult(longitude, latitude, result.result?.data)
            } else {
                showDialog(alertContent)
            }
            //await mapStore.searchStationByLatLon(longitude, latitude)
            loadingStore.setLoading(false)
        } catch (err) {
            console.log('err ::', err)
        } finally {
            loadingStore.setLoading(false)
        }
    }

    const showDialog = (message: string) => {
        if (openDialog) {
            openDialog({
                title: t('ALERT.TITLE.NOTIFY'),
                content: message,
                displayBtnClose: true,
            })
        }
    }

    const drawStationFromSearchKeyword = async (longitude: number, latitude: number, data: SearchResultType) => {
        await mapStore.drawSearchStationResult(longitude, latitude, data)
    }

    const handleMapDrag = (rotation: number, element?: SVGSVGElement) => {
        element?.setAttribute('style', `transform: rotate(${rotation}deg)`)
    }

    const handleClickMenuItem = (item?: any) => {
        resetSearchData()
        handleCloseSnackbar()
        formReportStore.setIsOpenDrawerFeedback(true)
        setOpenDrawer(!openDrawer)
        if (item.id != 1 && item.id != 7 && item.id != 8) {
            mapStore.identifyResult = null
            mapStore.searchResult = null
            setOpenPopupIdentifyResult(false)
        }
        return item.id
    }

    const handleClickDrawerDim = () => {
        setOpenDrawer(false)
    }

    const handleOpenDrawer = () => {
        setOpenDrawer(true)
    }

    const handleCloseDrawer = () => {
        setOpenDrawer(false)
    }

    const handleOpenDialogSearchGuide = () => {
        setOpenDialogSearchGuide(true)
    }

    const handleCloseDialogSearchGuide = () => {
        setOpenDialogSearchGuide(false)
    }

    const handleOpenPopupIdentifyResult = () => {
        setOpenPopupIdentifyResult(true)
    }

    const handleClosePopupIdentifyResult = () => {
        mapStore.clearIdentifyStation()
        setOpenPopupIdentifyResult(false)
        // setExpandedResult(true)
    }

    const handleClickRotation = () => {
        mapStore.setMapViewRotation(0)
        //mapStore._view.rotation = 0
        // const elementIcon = document.getElementsByClassName('icon-navigation-rotate')
        // elementIcon[0].setAttribute('style', `transform: rotate(0deg);`)
    }

    const handleCheckPinLayer = () => {
        mapStore.setVisibleLayer('station-layer')
        setVisiblePinLayer(!visiblePinLayer)
    }

    const handleCheckCoverageAreaLayer = () => {
        mapStore.setVisibleSubLayer('mapOra-Layer', 1)
        setVisibleCoverageAreaLayer(!visibleCoverageAreaLayer)
    }

    const handleCheckAntennaPattern = () => {
        mapStore.setVisibleSubLayer('mapOra-Layer', 5)
        setVisibleAntennaPatternLayer(!visibleAntennaPatternLayer)
    }

    const handleClickCurrentLocation = () => {
        const url = globalThis.location.href
        if (!url.includes('reset-password')) {
            navigator?.geolocation?.getCurrentPosition(
                (position: GeolocationPosition) => {
                    const { longitude, latitude } = position.coords
                    mapStore.setSelectedLocation({ latitude, longitude })
                    searchStationByLatLon(longitude, latitude, t('ALERT.CONTENT.STATION_NOT_FOUND_CURRENT_LOCATION'))
                },
                () => {
                    setOpenDialogLocationBlock(true)
                },
            )
        }
    }

    const handleClickZoomIn = () => {
        let zoomIn = mapStore.currentZoom + 1
        let opts = {
            duration: 200,
        }
        mapStore._view.goTo(
            {
                zoom: zoomIn,
            },
            opts,
        )
    }

    const handleClickZoomOut = () => {
        let zoomIn = mapStore.currentZoom - 1
        let opts = {
            duration: 200,
        }
        mapStore._view.goTo(
            {
                zoom: zoomIn,
            },
            opts,
        )
    }

    const handleClickStationResult = (item: StationType) => {
        item.displayAzimuthAndDistance = true
        setIdentifyData(item)
        setOpenPopupIdentifyResult(true)

        const stationLocation: LocationType = {
            latitude: item.latitude || 0,
            longitude: item.longitude || 0,
        }
        if (mapStore.currentLocation) {
            mapStore.drawGraphicLine(mapStore.currentLocation, stationLocation)
        }
        //mapStore.drawGraphicStationSelected(item)
    }

    const handleClickShowResult = () => {
        setExpandedResult(true)
    }

    const handleClickHideResult = () => {
        setExpandedResult(false)
    }

    const handleBaseMapSelected = (name?: string) => {
        if (name === 'streets') {
            mapStore._map.basemap = undefined as any
            if (mapStore.useMainStreetMap) {
                mapStore._map.basemap = { baseLayers: [mapStore._layerStreetBasemap] } as any
            } else {
                mapStore._map.basemap = 'streets' as any
            }
        } else if (name === 'hybrid') {
            mapStore._map.basemap = undefined as any
            mapStore._map.basemap = mapStore._hybridVectorBasemap as any
        } else {
            mapStore._map.basemap = name as any
        }
    }

    const handleOpenSnackbar = () => {
        setOpenSnackbar(true)
    }

    const handleCloseSnackbar = () => {
        mapStore.setViewClickEvent(MapViewClickType.Identify)
        setOpenSnackbar(false)
    }

    const handleClickSearchByLatLon = () => {
        mapStore.setViewClickEvent(MapViewClickType.SearchStation)
        setOpenSnackbar(true)
    }

    const resetSearchData = () => {
        setSearchData(undefined)
        setOpenPopupIdentifyResult(false)
        // mapStore._graphicReceptorLayer.removeAll()
        // mapStore._graphicSearchStationLayer.removeAll()
        mapStore.clearSearchGraphicAll()
        mapStore.displayHidingSearchStation()
        mapStore.setMapUpperBar(true)
    }

    const onClickMapResult = () => {
        if (mapUpperBarStore.anchorElResult) {
            mapUpperBarStore.setAnchorElResult(null)
        }
        if (mapUpperBarStore.anchorElNoResult) {
            mapUpperBarStore.setAnchorElNoResult(null)
        }
    }

    const handleCloseDialogLocationBlock = () => {
        setOpenDialogLocationBlock(false)
    }

    return {
        refElementMap,
        refComponentTopLeft,
        refComponentTopRight,
        refComponentBottomScreenWeb,
        refComponentBottomScreenMobile,
        refElementLocationRealtime,
        zoomToPoint,
        menuList,
        openDrawer,
        isDisabledMaptool: formReportStore.isDisabledMapTool,
        onClickMenuItem: handleClickMenuItem,
        onClickDrawerDim: handleClickDrawerDim,
        onCloseDrawer: handleCloseDrawer,
        onOpenDrawer: handleOpenDrawer,
        openDialogSearchGuide,
        onOpenDialogSearchGuide: handleOpenDialogSearchGuide,
        onCloseDialogSearchGuide: handleCloseDialogSearchGuide,
        openDialogWelcome,
        onClickAcceptDialogWelcome: handleClickAcceptDialogWelcome,
        searchData,
        identifyData,
        openPopupIdentifyResult,
        onOpenPopupIdentifyResult: handleOpenPopupIdentifyResult,
        onClosePopupIdentifyResult: handleClosePopupIdentifyResult,
        onClickRotation: handleClickRotation,
        visiblePinLayer,
        visibleCoverageAreaLayer,
        visibleAntennaPatternLayer,
        onCheckPinLayer: handleCheckPinLayer,
        onCheckCoverageAreaLayer: handleCheckCoverageAreaLayer,
        onCheckAntennaPattern: handleCheckAntennaPattern,
        onClickCurrentLocation: handleClickCurrentLocation,
        onClickZoomIn: handleClickZoomIn,
        onClickZoomOut: handleClickZoomOut,
        onClickStationResult: handleClickStationResult,
        expandedResult,
        onClickShowResult: handleClickShowResult,
        onClickHideResult: handleClickHideResult,
        onBaseMapSelected: handleBaseMapSelected,
        openSnackbar,
        onOpenSnackbar: handleOpenSnackbar,
        onCloseSnackbar: handleCloseSnackbar,
        onClickSearchByLatLonTool: handleClickSearchByLatLon,
        openDialogLocationBlock,
        onClickCloseDialogLocationBlock: handleCloseDialogLocationBlock,
        searchStationByLatLon,
        drawStationFromSearchKeyword,
        showDialog,
        resetSearchData,
        dataTermsAndConditions,
        dataContact,
        onClickMapResult,
    }
}

export default useMap
